import { render, staticRenderFns } from "./lapCustom.vue?vue&type=template&id=57ad4c42&"
import script from "./lapCustom.vue?vue&type=script&lang=js&"
export * from "./lapCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QSeparator,QSelect,QItem,QItemSection,QIcon,QPopupProxy,QDate,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QSeparator,QSelect,QItem,QItemSection,QIcon,QPopupProxy,QDate,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
